const WHITELISTED_USER_DATA = ['firstname', 'email'];

export default {
  WHITELISTED_USER_DATA
};
